import { CONSULTATIONS_ROUTE, HOME_ROUTE, PRESCRIPTIONS_ROUTE } from '@/routes/route-paths';
import { ClassicContentCard } from '@montugroup/circuit-shared/components/braze/ClassicContentCard';
import { useLocation } from 'react-router-dom';
import { BRAZE_CONTENT_CARD } from './enums';

export const BrazePageMessaging = () => {
  const location = useLocation();

  switch (location.pathname) {
    case CONSULTATIONS_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_CONSULTATIONS} isTopBanner />;
    case HOME_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_HOME} isTopBanner />;
    case PRESCRIPTIONS_ROUTE:
      return <ClassicContentCard page={BRAZE_CONTENT_CARD.PATIENT_PRESCRIPTIONS} isTopBanner />;
    default:
      break;
  }
};
